import { initialStateAuth } from '../../auth/store/auth.reducer'

import { initialState as barringState } from '~/barrings/store/barring.reducer'
import { initialState as bonusState } from '~/bonus/store/bonus.reducer'
import { initialState as brandInitialState } from '~/brand/store/brand.reducer'
import { initialState as consumptionState } from '~/consumptions/store/consumption.reducer'
import { initialState as customerInitialState } from '~/customer/store/customer.reducer'
import { initialState as discountState } from '~/discounts/store/discount.reducer'
import { initialState as featureFlagsInitialState } from '~/featureFlags/store/featureFlags.reducer'
import { initialState as serviceState } from '~/services/store/service.reducer'
import { initialState as subscriptionDetailState } from '~/subscriptionDetail/store/subscriptionDetail.reducer'

export const rootInitialState = {
  auth: initialStateAuth,
  brand: brandInitialState,
  customer: customerInitialState,
  featureFlags: featureFlagsInitialState,
  bonuses: bonusState,
  consumptions: consumptionState,
  subscriptionDetail: subscriptionDetailState,
  discounts: discountState,
  services: serviceState,
  barrings: barringState,
}

export default rootInitialState
